<div class="text-center d-block d-md-none">
  <pwa-installer class="mt-5 mb-3"></pwa-installer>
</div>

<footer class="page-footer">
  <div class="container">
    <div class="text-container">
      <div class="account footer-item">
        <h4>Your Account</h4>
        @if (!isLoggedIn()) {
        <ul>
          <li>
            <button (click)="login()">
              <span class="login-logout">Log in</span>
            </button>
          </li>
          <li>
            <button (click)="signup()">
              <span class="login-logout">Sign up</span>
            </button>
          </li>
        </ul>
        } @else {
        <ul>
          <li>
            <a routerLink="/my-account" routerLinkActive="active"> Profile </a>
          </li>
          <!-- If logged in  -->
          <li>
            <button (click)="logout()">
              <span class="login-logout">Log Out</span>
            </button>
          </li>
        </ul>
        }
      </div>
      <div class="discover footer-item">
        <h4>Discover</h4>
        <ul>
          <li>
            <a
              id="nav-item-events"
              routerLinkActive="active"
              routerLink="/events/event-list"
            >
              Events
            </a>
          </li>
          <li>
            <a
              id="nav-item-communities"
              routerLinkActive="active"
              routerLink="/communities"
            >
              Communities
            </a>
          </li>

          <li>
            <a
              id="nav-item-network"
              routerLinkActive="active"
              routerLink="/networks"
            >
              Networks
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-item">
        <h4>More</h4>
        <ul>
          <li>
            <a
              id="nav-item-about"
              routerLinkActive="active"
              routerLink="/about"
            >
              About Upskill
            </a>
          </li>
          <li>
            <a
              id="nav-item-feedback"
              routerLinkActive="active"
              routerLink="/feedback"
              >Feedback</a
            >
          </li>
          <li>
            <a routerLink="/about/hosting-event"> How to host an event </a>
          </li>

          <li>
            <a id="nav-item-privacy" routerLinkActive="active" routerLink="/privacy"> Privacy Policy </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="logo-container">
      <img
        src="/assets/img/Cap-swish.svg"
        alt=""
        class="capswosh d-lg-block d-none"
      />
    </div>
    <div class="bottom-div">
      <div>&copy; {{ year }} Upskill</div>
      <a onclick="window.location.href='https://www.capgemini.com/no-no/'">
        <img
          class="logoimg"
          height="40"
          title="capgemini"
          src="/assets/img/capgemini-logo.png"
        />
      </a>
    </div>
  </div>
</footer>
